<template>

    <FloatingPanel title="Project suggesties">

        <div class="canvas::blocks-modules-projectSuggestions-BlockPanel">

             <Tabs :tabs="[
                'Maatwerk',
                'Algemeen',
            ]">

                <div slot="Maatwerk">

                    <SwitchInput
                        label="Filter cases (op)"
                        instruction="Bepaal hier of de cases gefilterd moeten worden op tags en/of branches."
                        :options="options"
                        options-property="filter"
                        :items="[
                            { value: 'both', label: 'Tags & branches'},
                            { value: 'tags', label: 'Tags'},
                            { value: 'branches', label: 'Branches'},
                            { value: 'none', label: 'Geen' },
                        ]"
                        defaultValue="both"
                        :open="true"
                    />

                    <accordion-input v-if="showFilterSelections" :open="true">
                        <template #label>
                            <div class="font-medium text-gray-600">Specifieke filters</div>
                        </template>
                        <template #content>
                            <small class="block mb-3 text-gray-600 label text-muted">
                                Selecteer welke {{ filterTypeLabel }} je wilt tonen.
                            </small>

                            <div v-if="showBothFilters">
                                <div class="mb-4">
                                    <label class="block mb-2 text-sm font-medium text-gray-600">Tags</label>
                                    <v-select
                                        :options="tags"
                                        label="title"
                                        v-model="options.selected_tags"
                                        :reduce="tag => tag.id"
                                        multiple
                                        :loading="loadingData"
                                        placeholder="Selecteer tags..."
                                    >
                                        <div slot="no-options">
                                            <span v-if="loadingData">Tags laden...</span>
                                            <span v-else>Geen tags beschikbaar</span>
                                        </div>
                                    </v-select>
                                </div>

                                <div>
                                    <label class="block mb-2 text-sm font-medium text-gray-600">Branches</label>
                                    <v-select
                                        :options="branches"
                                        label="title"
                                        v-model="options.selected_branches"
                                        :reduce="branch => branch.id"
                                        multiple
                                        :loading="loadingData"
                                        placeholder="Selecteer branches..."
                                    >
                                        <div slot="no-options">
                                            <span v-if="loadingData">Branches laden...</span>
                                            <span v-else>Geen branches beschikbaar</span>
                                        </div>
                                    </v-select>
                                </div>
                            </div>

                            <div v-else-if="showTagsOnly">
                                <v-select
                                    :options="tags"
                                    label="title"
                                    v-model="options.selected_tags"
                                    :reduce="tag => tag.id"
                                    multiple
                                    :loading="loadingData"
                                    placeholder="Selecteer tags..."
                                >
                                    <div slot="no-options">
                                        <span v-if="loadingData">Tags laden...</span>
                                        <span v-else>Geen tags beschikbaar</span>
                                    </div>
                                </v-select>
                            </div>

                            <div v-else-if="showBranchesOnly">
                                <v-select
                                    :options="branches"
                                    label="title"
                                    v-model="options.selected_branches"
                                    :reduce="branch => branch.id"
                                    multiple
                                    :loading="loadingData"
                                    placeholder="Selecteer branches..."
                                >
                                    <div slot="no-options">
                                        <span v-if="loadingData">Branches laden...</span>
                                        <span v-else>Geen branches beschikbaar</span>
                                    </div>
                                </v-select>
                            </div>
                        </template>
                    </accordion-input>

                    <SwitchInput
                        label="Toon ongefilterde cases"
                        instruction="Toon cases die niet overeenkomen met de filters indien er 'te weinig' resultaten zijn met de filters."
                        :options="options"
                        options-property="show_unfiltered_cases"
                        :items="[
                            { value: '1', label: 'Ja'},
                            { value: '0', label: 'Nee'},
                        ]"
                        defaultValue="0"
                    />

                </div>

                <div slot="Algemeen">

                    <CommonInputs
                        :options="options"
                    />

                </div>

            </Tabs>

        </div>

    </FloatingPanel>

</template>

<script>

import AbstractPanel from '@galaxy/modules/Canvas/resources/js/editor/website/editors/AbstractPanel';
import FloatingPanel from '@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/FloatingPanel';
import CommonInputs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/CommonInputs";
import Tabs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/Tabs";
import SwitchInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/SwitchInput";
import AccordionInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/helpers/Input";
import axios from "@galaxy/modules/Core/resources/js/axiosBuilder";
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {

    extends: AbstractPanel,

    components: {
        FloatingPanel,
        CommonInputs,
        Tabs,
        SwitchInput,
        AccordionInput,
        vSelect,
    },

    data() {
        return {
            tags: [],
            branches: [],
            loadingData: false,
        };
    },

    created() {
        this.fetchTagsAndBranches();
    },

    computed: {
        filterType() {
            return this.options.filter || 'both';
        },

        showFilterSelections() {
            return this.filterType !== 'none';
        },

        showBothFilters() {
            return this.filterType === 'both';
        },

        showTagsOnly() {
            return this.filterType === 'tags';
        },

        showBranchesOnly() {
            return this.filterType === 'branches';
        },

        filterTypeLabel() {
            if (this.filterType === 'both') return 'tags en branches';
            if (this.filterType === 'tags') return 'tags';
            if (this.filterType === 'branches') return 'branches';
            return '';
        },
    },

    methods: {
        async fetchTagsAndBranches() {
            this.loadingData = true;

            try {
                const url = '/common/canvas/blocks/project/modules/projectSuggestions/projects/tags-and-branches';
                const response = await axios.get(url);

                this.tags = response.data.tags || [];
                this.branches = response.data.branches || [];
            } catch (error) {
                console.error("Error fetching tags and branches", error);
                this.tags = [];
                this.branches = [];
            } finally {
                this.loadingData = false;
            }
        },
    },

}

</script>
